import {fork} from 'redux-saga/effects';
import {importerSaga} from "./areas/importer/importerSaga";
import {googleCalendarSaga} from "./areas/importer/googleCalendarSaga";

export function* rootSaga() {
    yield fork(importerSaga);
    yield fork(googleCalendarSaga);
}